var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuilding07(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.24984 9.66667H3.83317C3.36646 9.66667 3.13311 9.66667 2.95485 9.75749C2.79804 9.83739 2.67056 9.96487 2.59067 10.1217C2.49984 10.2999 2.49984 10.5333 2.49984 11V18M13.7498 9.66667H16.1665C16.6332 9.66667 16.8666 9.66667 17.0448 9.75749C17.2016 9.83739 17.3291 9.96487 17.409 10.1217C17.4998 10.2999 17.4998 10.5333 17.4998 11V18M13.7498 18V5.66667C13.7498 4.73325 13.7498 4.26654 13.5682 3.91002C13.4084 3.59641 13.1534 3.34144 12.8398 3.18166C12.4833 3 12.0166 3 11.0832 3H8.9165C7.98308 3 7.51637 3 7.15985 3.18166C6.84625 3.34144 6.59128 3.59641 6.43149 3.91002C6.24984 4.26654 6.24984 4.73325 6.24984 5.66667V18M18.3332 18H1.6665M9.1665 6.33333H10.8332M9.1665 9.66667H10.8332M9.1665 13H10.8332",
    stroke: "#444CE7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding07);
export default __webpack_public_path__ + "static/media/building-07.88364d967f62eadb3bf90a53d6800ce3.svg";
export { ForwardRef as ReactComponent };